import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/BonusCardRequestBalance/bonusCardRequestBalance.container"
    ).then((module) => ({ default: module.BonusCardRequestBalanceContainer }))
);
